<template>
  <button
    class="toggle-button button"
    v-on:click="onclick"
    v-bind:class="{
      disabled,
      blue,
      white,
      khaki,
      pink,
      'pure-icon': pureIcon,
      'rounded-corner': roundedCorner
    }"
    type="button"
    :title="pureIcon ? text : ''"
  >
    <span v-if="!pureIcon">{{ text }}</span>
    <slot v-if="hasIcon" name="icon" />
  </button>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    text: String,
    blue: Boolean,
    white: Boolean,
    khaki: Boolean,
    pink: Boolean,
    disabled: Boolean,
    pureIcon: Boolean,
    roundedCorner: Boolean
  },
  computed: {
    hasIcon() {
      return !!this.$slots.icon;
    }
  },
  methods: {
    onclick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/scss/colors';

.toggle-button {
  height: 40px;
  border: 1px solid $babyPowder;
  display: inline-block;
  box-sizing: border-box;
  padding: 0 20px;
  color: $babyPowder;
  background-color: $geranium;
  font-size: 16px;
  font-weight: bold;
  transition: all .2s ease-in-out;
  cursor: pointer;
  position: relative;
  user-select: none;
  box-shadow: 0px 3px 6px #00000029;
  text-transform: capitalize;

  .icon {
    margin-left: 10px;
  }

  &.rounded-corner {
    border-radius: 20px;
  }

  &.blue {
    background-color: $blueNcs;
  }

  &.khaki {
    background-color: $khaki;
  }

  &.pink {
    background-color: $paradisePink;
  }

  &.disabled {
    color: $grey;
    border-color: $grey;
    pointer-events: none;
  }

  &.pure-icon {
    width: 40px;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;

    .icon {
      margin: 0;
    }
  }

  &:hover {
    background-color: $paradisePink;
  }

  &.white {
    background-color: $white;
    color: $geranium;
    border: 1px solid $white;

    &:hover {
      color: $independence;
    }
  }

  &:active, &:focus {
    outline: none;
  }
}
</style>
